import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useOrganization } from '../../hooks/useOrganization';
import { ROLE_LABELS } from '../../utils/permissions';
import { Badge } from '@/components/ui/badge';
import { Spinner } from '@/components/ui/spinner';

const roleBadgeVariant = (role) => {
  const map = {
    owner: 'bg-amber-100 text-amber-800',
    admin: 'bg-blue-100 text-blue-800',
    editor: 'bg-emerald-100 text-emerald-800',
    brief_editor: 'bg-pink-100 text-pink-800',
    viewer: 'bg-slate-100 text-slate-600',
  };
  return map[role] || 'bg-slate-100 text-slate-600';
};

const OrgPicker = () => {
  const navigate = useNavigate();
  const { user, organizations, loading: authLoading } = useAuth();
  const { setCurrentOrg, isLoading: orgLoading } = useOrganization();

  const handleSelectOrg = (org) => {
    setCurrentOrg(org);
    navigate(`/org/${org.slug}/creatives`);
  };

  if (authLoading || orgLoading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="max-w-[600px] w-full text-center">
        <h1 className="text-2xl font-semibold text-foreground mb-2">Select Organization</h1>
        <p className="text-base text-muted-foreground mb-8">
          Welcome back, {user?.name || 'User'}! Choose an organization to continue.
        </p>

        <div className="flex flex-col gap-3">
          {organizations.map((org) => (
            <button
              key={org.id}
              className="flex items-center gap-4 p-4 bg-card border border-border rounded-xl cursor-pointer transition-all text-left w-full hover:border-coral hover:shadow-md hover:-translate-y-0.5"
              onClick={() => handleSelectOrg(org)}
            >
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-coral to-coral-hover text-white flex items-center justify-center text-xl font-semibold shrink-0">
                {org.name.charAt(0).toUpperCase()}
              </div>
              <div className="flex-1">
                <h3 className="text-base font-semibold text-foreground mb-1">{org.name}</h3>
                <span className={`text-xs font-medium px-2 py-0.5 rounded capitalize ${roleBadgeVariant(org.role)}`}>
                  {ROLE_LABELS[org.role] || org.role}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrgPicker;
